<p-toast [style]="{marginTop: '80px'}"></p-toast>

<div class="grid" style="max-width:1580px;margin:0 auto;">
  <div class="col">

    <!--
      Top toolbar: Hotel Center external link + lookback dropdown + manual
      refresh. Kept lean so it doesn't push the tab content down too far.
    -->
    <div class="flex flex-wrap align-items-center justify-content-between mb-3 gap-2">
      <div class="flex align-items-center gap-2">
        <a pButton
           icon="pi pi-external-link"
           label="Open Google Hotel Center (Price Accuracy)"
           class="p-button-outlined p-button-sm"
           [href]="hotelCenterUrl"
           target="_blank"
           rel="noopener noreferrer">
        </a>
      </div>

      <div class="flex align-items-center gap-2">
        <span class="text-sm">Dashboard window:</span>
        <p-dropdown
          [options]="daysBackOptions"
          [(ngModel)]="daysBack"
          optionLabel="label"
          optionValue="value"
          (onChange)="onDaysBackChange()"
          [style]="{minWidth: '140px'}">
        </p-dropdown>
        <button pButton
                icon="pi pi-refresh"
                class="p-button-text p-button-sm"
                (click)="loadDashboard()"
                [disabled]="dashboardLoading"
                pTooltip="Refresh dashboard">
        </button>
      </div>
    </div>

    <!--
      Status dashboard: one card per Google feed with PASS / WARN / FAIL
      counts of distinct properties over the chosen window. Backed by a
      single GROUP BY query so the page loads fast.
    -->
    <div class="grid mb-3">
      @for (tile of dashboardTiles; track tile.testName) {
        <div class="col-12 sm:col-6 lg:col-2 xl:col-2">
          <p-card [header]="tile.label" styleClass="text-center sync-tile">
            <div class="flex justify-content-around align-items-center">
              <div>
                <div class="text-green-500 font-bold text-xl">{{ tile.pass }}</div>
                <small>Pass</small>
              </div>
              <div>
                <div class="text-orange-500 font-bold text-xl">{{ tile.warn }}</div>
                <small>Warn</small>
              </div>
              <div>
                <div class="text-red-500 font-bold text-xl">{{ tile.fail }}</div>
                <small>Fail</small>
              </div>
            </div>
          </p-card>
        </div>
      }
    </div>

    <p-tabView [(activeIndex)]="tabIndex">
      <p-tabPanel header="Unit Availability Sync">
        <div class="p-4">
          <p class="mb-3">
            For detailed Google sync reports, see
            <a href="https://admin.kbmhawaii.com/data-report" target="_blank" rel="noopener noreferrer">Data Report</a>.
          </p>
          <p class="mb-3">
            For Google Logman endpoints and examples, see
            <a routerLink="/google-logman" target="_blank" rel="noopener noreferrer">Google Logman</a>.
          </p>
          <app-google-data-table [testName]="'GoogleUnitAvailabilitySync'"></app-google-data-table>
        </div>
      </p-tabPanel>

      <p-tabPanel header="Inv Count Sync">
        <div class="p-4">
          <p class="mb-3">
            For detailed Google sync reports, see
            <a href="https://admin.kbmhawaii.com/data-report" target="_blank" rel="noopener noreferrer">Data Report</a>.
          </p>
          <p class="mb-3">
            For Google Logman endpoints and examples, see
            <a routerLink="/google-logman" target="_blank" rel="noopener noreferrer">Google Logman</a>.
          </p>
          <app-google-data-table [testName]="'GoogleInvCountSync'"></app-google-data-table>
        </div>
      </p-tabPanel>

      <p-tabPanel header="LOS Rate Sync">
        <div class="p-4">
          <p class="mb-3">
            For detailed Google sync reports, see
            <a href="https://admin.kbmhawaii.com/data-report" target="_blank" rel="noopener noreferrer">Data Report</a>.
          </p>
          <p class="mb-3">
            For Google Logman endpoints and examples, see
            <a routerLink="/google-logman" target="_blank" rel="noopener noreferrer">Google Logman</a>.
          </p>
          <app-google-data-table [testName]="'GoogleLosRateSync'"></app-google-data-table>
        </div>
      </p-tabPanel>

      <p-tabPanel header="Tax Fee Info Sync">
        <div class="p-4">
          <p class="mb-3">
            For detailed Google sync reports, see
            <a href="https://admin.kbmhawaii.com/data-report" target="_blank" rel="noopener noreferrer">Data Report</a>.
          </p>
          <p class="mb-3">
            For Google Logman endpoints and examples, see
            <a routerLink="/google-logman" target="_blank" rel="noopener noreferrer">Google Logman</a>.
          </p>
          <app-google-data-table [testName]="'GoogleTaxFeeInfoSync'"></app-google-data-table>
        </div>
      </p-tabPanel>

      <p-tabPanel header="VR Feed Upload">
        <div class="p-4">
          <p class="mb-3">
            For detailed Google sync reports, see
            <a href="https://admin.kbmhawaii.com/data-report" target="_blank" rel="noopener noreferrer">Data Report</a>.
          </p>
          <p class="mb-3">
            For Google Logman endpoints and examples, see
            <a routerLink="/google-logman" target="_blank" rel="noopener noreferrer">Google Logman</a>.
          </p>
          <app-google-data-table [testName]="'GoogleVrFeedUpload'"></app-google-data-table>
        </div>
      </p-tabPanel>
    </p-tabView>
  </div>
</div>
